// Инициализация ссылок на онлайн-офис

/**
 * Инициализация ссылок на онлайн-офис
 */
function main(): void
{
	const onlineOfficeLinks : Array<Element> = Array.from( document.querySelectorAll( 'html > body a[href*="online.sevensuns.ru"]' ) );

	if ( !onlineOfficeLinks.length )
	{
		return;
	}
	
	let oymcid : string = '?oymcid=';
	let metrica : boolean = false;
	
	Array.from( document.cookie.split( ';' ) ).forEach(
		( it ) =>
		{
			const key : string = it.split( '=' )[0];
			const value : string = it.split( '=' )[1];

			if ( key === '_ym_uid' )
			{
				metrica = true;
				oymcid += value;
			}
		}
	);

	if ( metrica )
	{
		onlineOfficeLinks.forEach(
			( it : Element ) =>
			{
				it.setAttribute( 'href', 'https://online.sevensuns.ru/' + oymcid );
			}
		);
	}
}

/**
 * Module
 */
export {
	main as default,
};



// WEBPACK FOOTER //
// ./app/Common/OnlineOffice/index.ts